import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {useTranslation} from 'react-i18next';
import {loadUser, loginUser} from '@store/reducers/auth';
import {Checkbox, Button, Input} from '@components';
import {faEnvelope, faLock, faUser} from '@fortawesome/free-solid-svg-icons';
import * as AuthService from '../../services/auth';
import {alertService} from "@app/services/alertService";
import {BASE_API} from '@app/const/AppSetting';
const Login = () => {
    const [isAuthLoading, setAuthLoading] = useState(false);
    const [isGoogleAuthLoading, setGoogleAuthLoading] = useState(false);
    const [isFacebookAuthLoading, setFacebookAuthLoading] = useState(false);
    const dispatch = useDispatch();

    const history = useHistory();
    const [t] = useTranslation();

    const login = async (email, password) => {
        try {
            setAuthLoading(true);
            console.log('email ' + email);
            console.log('password ' + password);
            const data = await AuthService.loginByAuth(email, password);
            setAuthLoading(false);
            if(!data.flag)
            {
                console.log('login error', JSON.stringify(data, null, 2));
                alertService.error(data.msg);
                return;
            }

            toast.success('Login is succeed!');
            setAuthLoading(false);
            dispatch(loginUser(data.accessToken));
            dispatch(loadUser(data));
            history.push('/');
        } catch (error) {
            console.log('login error', JSON.stringify(error, null, 2));
            setAuthLoading(false);
            toast.error(
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    'Failed'
            );
        }
    };


    const loginByGoogle = async () => {
        try {
            setGoogleAuthLoading(true);
            const token = await AuthService.loginByGoogle();
            toast.success('Login is succeeded!');
            setGoogleAuthLoading(false);
            dispatch(loginUser(token));
            history.push('/');
        } catch (error) {
            setGoogleAuthLoading(false);
            toast.error(
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    'Failed'
            );
        }
    };

    const loginByFacebook = async () => {
        try {
            setFacebookAuthLoading(true);
            const token = await AuthService.loginByFacebook();
            toast.success('Login is succeeded!');
            setFacebookAuthLoading(false);
            dispatch(loginUser(token));
            history.push('/');
        } catch (error) {
            setFacebookAuthLoading(false);
            toast.error(
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    'Failed'
            );
        }
    };

    const printFormError = (formik, key) => {
        if (formik.touched[key] && formik.errors[key]) {
            return <div>{formik.errors[key]}</div>;
        }
        return null;
    };

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        onSubmit: (values) => {
            login(values.email, values.password);
        }
    });

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box">
            <div className="card card-outline card-dark">
                <div className="card-header text-center">
                    <Link to="/" className="h1">
                            <div>
                                <img width={150} height={150} src={process.env.PUBLIC_URL + '/img/logo_xanh1.png'} alt="Logo"/>
                            </div>
                    </Link>
                </div>
                <div className="card-body">
                    <p className="login-box-msg">{t('login.label.signIn') }</p>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="mb-3">
                            <Input
                                icon={faUser}
                                placeholder="Tài khoản đăng nhập"
                                type="text"
                                {...formik.getFieldProps('email')}
                            />
                            {formik.touched.email && formik.errors.email ? (
                                <div>{formik.errors.email}</div>
                            ) : null}
                        </div>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder="Mật khẩu"
                                type="password"
                                {...formik.getFieldProps('password')}
                            />
                            {printFormError(formik, 'password')}
                        </div>

                        <div className="row">
                       <div className="col-8">
                               {/* <Checkbox
                                    checked={false}
                                    label={t('login.label.rememberMe')}
                                />*/}
                            </div>
                            <div className="col-4">
                                <Button
                                    theme="btn btn-dark p-2"
                                    block
                                    type="submit"
                                    isLoading={isAuthLoading}
                                    disabled={
                                        isFacebookAuthLoading ||
                                        isGoogleAuthLoading
                                    }
                                >
                                    {t('login.button.signIn.label')}
                                </Button>
                            </div>
                        </div>
                    </form>
                    {/* <div className="social-auth-links text-center mt-2 mb-3">
                        <Button
                            block
                            icon="facebook"
                            onClick={loginByFacebook}
                            isLoading={isFacebookAuthLoading}
                            disabled={isAuthLoading || isGoogleAuthLoading}
                        >
                            {t('login.button.signIn.social', {
                                what: 'Facebook'
                            })}
                        </Button>
                        <Button
                            block
                            icon="google"
                            theme="danger"
                            onClick={loginByGoogle}
                            isLoading={isGoogleAuthLoading}
                            disabled={isAuthLoading || isFacebookAuthLoading}
                        >
                            {t('login.button.signIn.social', {what: 'Google'})}
                        </Button>
                    </div> */}
                   {/* <p className="mb-1">
                        <Link to="/forgot-password">
                            {t('login.label.forgotPass')}
                        </Link>
                    </p>
                    <p className="mb-0">
                        <Link to="/register" className="text-center">
                            {t('login.label.registerNew')}
                        </Link>
                    </p>*/}
                </div>
            </div>
        </div>
    );
};

export default Login;
